export default {"src":"/_next/static/media/featuresSVG.4be8cd8f.svg","height":704,"width":1440,"blurWidth":0,"blurHeight":0};